import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { GLOBAL_MODULE_ANNOUNCEMENT_ACTION_CREATORS } from './global-module-announcement.actions';
import { AnnouncementVM, GlobalModuleAnnouncementState } from './global-module-announcement.reducer';
import { globalModuleAnnouncementSelectors } from './global-module-announcement.selectors';

@Injectable()
export class GlobalModuleAnnouncementFacade {
  public readonly notDismissedAnnouncements$: Observable<AnnouncementVM[]> = this.store.select(
    globalModuleAnnouncementSelectors.selectNotDismissedAnnouncements,
  );

  constructor(private store: Store<GlobalModuleAnnouncementState>) {}

  public loadAnnouncements(): void {
    this.store.dispatch(GLOBAL_MODULE_ANNOUNCEMENT_ACTION_CREATORS.load());
  }

  public dismissAnnouncements(payload: string[]) {
    this.store.dispatch(GLOBAL_MODULE_ANNOUNCEMENT_ACTION_CREATORS.dismiss({ payload }));
  }
}
